const size = {
  mobileS: "375px",
  mobile: "429px",
  mobileL: "540px", // sm
  tablet: "768px",
  tabletL: "835px", // md
  laptop: "1024px", // lg
  lcd: "1080px",
  desktop: "1440px", // xl
  desktopL: "1920px",
};

export const device = {
  mobileS: `(max-width: ${size.mobileS})`,
  mobile: `(max-width: ${size.mobile})`,
  mobileL: `(max-width: ${size.mobileL})`,
  tablet: `(max-width: ${size.tablet})`,
  tabletL: `(max-width: ${size.tabletL})`,
  laptop: `(max-width: ${size.laptop})`,
  lcd: `(max-width: ${size.lcd})`,
  desktop: `(max-width: ${size.desktop})`,
  desktopL: `(max-width: ${size.desktopL})`,
};

export default device;
